import React from "react";

const Kotlin_Ranges = () => {
  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Kotlin Ranges</h1>
      <p>Content for Kotlin Ranges goes here.</p>
    </div>
  );
};

export default Kotlin_Ranges;
